"use strict";

exports.__esModule = true;
exports.debounce = debounce;
/**
 * Debounce a function.
 */
function debounce(func, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options,
    _options$delay = _options.delay,
    delay = _options$delay === void 0 ? 200 : _options$delay,
    _options$immediate = _options.immediate,
    immediate = _options$immediate === void 0 ? false : _options$immediate;
  var timeout = null;
  var args = null;
  var context = null;
  var timestamp = 0;
  var result = null;
  function later() {
    var last = Date.now() - timestamp;
    if (last < delay && last >= 0) {
      timeout = setTimeout(later, delay - last);
    } else {
      timeout = null;
      if (!immediate && args !== null) {
        result = func.apply(context, args);
        context = null;
        args = null;
      }
    }
  }
  function debounced() {
    context = this;
    for (var _len = arguments.length, inputArgs = new Array(_len), _key = 0; _key < _len; _key++) {
      inputArgs[_key] = arguments[_key];
    }
    args = inputArgs;
    timestamp = Date.now();
    var callNow = immediate && !timeout;
    if (!timeout) timeout = setTimeout(later, delay);
    if (callNow && args !== null) {
      result = func.apply(context, args);
      context = null;
      args = null;
    }
    return result;
  }
  debounced.cancel = function () {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };
  return debounced;
}